<script lang="ts" setup>
import type { AppMaskType } from './AppMask.model';

interface AppMaskProps {
  type: AppMaskType;
}

const props = defineProps<AppMaskProps>();
</script>

<template>
  <div :class="{ 'app-mask': true, [props.type]: true }">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.app-mask {
  &.right {
    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 5%
    );
    -webkit-mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 5%
    );
  }

  &.both {
    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 5%,
      rgba(255, 255, 255, 1) 95%,
      rgba(255, 255, 255, 0) 100%
    );
    -webkit-mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 5%,
      rgba(255, 255, 255, 1) 95%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  &.left {
    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 1) 95%,
      rgba(255, 255, 255, 0) 100%
    );
    -webkit-mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 1) 95%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  &.none {
    mask: none;
    -webkit-mask: none;
  }
}
</style>
